export default {"src":"/_next/static/media/ethereum.cda4f2bf.svg","height":1277,"width":784,"blurWidth":0,"blurHeight":0};